import React from 'react';

let Finals = () => {
	return <h1>Finals</h1>;
}

export default Finals;
